import i18n from '@/libs/i18n'

export default [
  {
    path: '/error',
    name: 'errors-error',
    component: () => import('@/views/errors/Error.vue'),
    meta: {
      pageTitle: i18n.t('Error'),
      layout: 'horizontal',
      action: 'read',
      resource: 'errors',
    },
  },
  {
    path: '/error-404',
    name: 'errors-404',
    component: () => import('@/views/errors/Error404.vue'),
    meta: {
      pageTitle: i18n.t('Page Not Found'),
      layout: 'horizontal',
      action: 'read',
      resource: 'errors',
    },
  },
  {
    path: '/not-authorized',
    name: 'errors-not-authorized',
    component: () => import('@/views/errors/NotAuthorized.vue'),
    meta: {
      pageTitle: i18n.t('Not authorized'),
      layout: 'horizontal',
    },
  },
]
